import { supabase } from "../supabase";

let cachedAccessToken: string | null = null;
let sessionPromise: Promise<string | null> | null = null;
let tokenGeneration = 0;

export const setAccessToken = (token: string | null) => {
  cachedAccessToken = token;
};

export const clearAccessToken = () => {
  cachedAccessToken = null;
  sessionPromise = null;
  tokenGeneration += 1;
};

export const getCachedAccessToken = () => cachedAccessToken;

export const getAccessToken = async (): Promise<string | null> => {
  if (cachedAccessToken) {
    return cachedAccessToken;
  }

  if (sessionPromise) {
    return sessionPromise;
  }

  const generation = tokenGeneration;
  sessionPromise = supabase.auth
    .getSession()
    .then(({ data: { session } }) => {
      if (generation !== tokenGeneration) {
        return null;
      }
      cachedAccessToken = session?.access_token ?? null;
      return cachedAccessToken;
    })
    .finally(() => {
      sessionPromise = null;
    });

  return sessionPromise;
};
